import { IReferral } from '@sales-center/common'
import { produce } from 'immer'
import type { State } from '../../typings'

export function setReferralProducer(
  state: State,
  payload: IReferral | null,
): State {
  return {
    ...state,
    ...produce(state, (draft) => {
      if (payload && payload.referralType) {
        switch (payload.referralType) {
          case 'Customer':
            draft.referralType = 'Customer'
            draft.referralCustomerId = payload.referralValue
            break
          case 'Employee':
            draft.referralType = 'Employee'
            draft.referralEmployeeValue = payload.referralValue
            draft.referralEmployeeId = payload.referralEmployeeId
            break
          case 'Other':
            draft.referralType = 'Other'
            draft.referralOther = payload.referralValue
            break
          case 'None':
            draft.referralType = 'None'
            break
        }
      }
    }),
    ...payload,
  }
}
